/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClrCommonPopoverModule } from "../common/popover.module";
import { ClrIconModule } from "../../icon/icon.module";
import { SIGNPOST_DIRECTIVES } from "./index";
var ClrSignpostModule = (function () {
    function ClrSignpostModule() {
    }
    return ClrSignpostModule;
}());
export { ClrSignpostModule };
ClrSignpostModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    ClrCommonPopoverModule,
                    ClrIconModule
                ],
                declarations: [
                    SIGNPOST_DIRECTIVES
                ],
                exports: [
                    SIGNPOST_DIRECTIVES
                ],
                providers: []
            },] },
];
/** @nocollapse */
ClrSignpostModule.ctorParameters = function () { return []; };
//# sourceMappingURL=signpost.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/popover/signpost/signpost.module.js
// module id = 303
// module chunks = 4